const HERO_VIDEO_SELECTOR = 'starry-hero-video';
const PLAYING_CLASS = 'starry-hero__media--playing';

class StarryHeroVideo extends HTMLElement {
  constructor() {
    super();
    this.abortController = null;
    this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  }

  connectedCallback() {
    this.abortController?.abort();
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    const video = this.querySelector('[data-starry-hero-video]');

    if (!(video instanceof HTMLVideoElement)) return;

    this.video = video;
    video.defaultMuted = true;
    video.muted = true;
    video.addEventListener('playing', () => this.classList.add(PLAYING_CLASS), { signal });
    video.addEventListener('error', () => this.showFallback(), { signal });

    const updatePlayback = () => {
      if (this.motionPreference.matches) {
        this.unloadVideo();
      } else {
        this.loadAndPlayVideo();
      }
    };

    if (typeof this.motionPreference.addEventListener === 'function') {
      this.motionPreference.addEventListener('change', updatePlayback, { signal });
    } else {
      this.motionPreference.addListener(updatePlayback);
      signal.addEventListener('abort', () => this.motionPreference.removeListener(updatePlayback), { once: true });
    }

    updatePlayback();
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.video?.pause();
  }

  loadAndPlayVideo() {
    if (!(this.video instanceof HTMLVideoElement)) return;

    this.video.querySelectorAll('source[data-src]').forEach((source) => {
      if (!source.hasAttribute('src')) source.src = source.dataset.src;
    });
    this.video.load();

    const playPromise = this.video.play();
    playPromise?.catch(() => this.showFallback());
  }

  unloadVideo() {
    if (!(this.video instanceof HTMLVideoElement)) return;

    this.showFallback();
    this.video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
    this.video.load();
  }

  showFallback() {
    this.classList.remove(PLAYING_CLASS);
    this.video?.pause();
  }
}

if (!customElements.get(HERO_VIDEO_SELECTOR)) {
  customElements.define(HERO_VIDEO_SELECTOR, StarryHeroVideo);
}
